import { Link } from '@tanstack/react-router';

export default function NotFoundComponent() {
  return (
    <div>
      <h2>Page not found</h2>
      <p>The page you are looking for does not exist.</p>
      <Link to="/{-$locale}" params={{ locale: undefined }}>
        Go to Home
      </Link>
    </div>
  );
}
